import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { filterLocationUrl, filterSectorByIndutry , filterGroupUrl, filterAcquirerGroupUrl } from '../../Config/config';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { TableHeaderContext } from '../../Contexts/TableHeaderContext';
import { UserContext } from '../../Contexts/UserContext';
import AcquirerDealRangeFilter from '../RefineSearchComponents/AcquirerDealRangeFilter';
import AcquirerTypeFilter from '../RefineSearchComponents/AcquirerTypeFilter';
import CityFilter from '../RefineSearchComponents/CityFilter';
import CompanyTypeFilter from '../RefineSearchComponents/CompanyTypeFilter';
import CountryFilter from '../RefineSearchComponents/CountryFilter';
import DealTypeFilter from '../RefineSearchComponents/DealTypeFilter';
import IndustryFilter from '../RefineSearchComponents/IndustryFilter';
import AcqIndustryFilter from '../RefineSearchComponents/AcquirerIndustry';
import RegionFilter from '../RefineSearchComponents/RegionFilter';
import StateFilter from '../RefineSearchComponents/StateFilter';
import ValuationFilter from '../RefineSearchComponents/ValuationFilter';
import { TableDataContext } from '../../Contexts/TableDataContext';
import Constants from '../../Constants';
import SectorFilter from '../RefineSearchComponents/SectorFilter';
import TargetGroup from '../RefineSearchComponents/TargetGroup';
import AcquirerGroup from '../RefineSearchComponents/AcquirerGroup';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import {filterTargetCompany ,filterAcquirers,filterlAdvisors,filtertAdvisors } from "../../Config/config"
import Acquirers from '../RefineSearchComponents/Acquirers';
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
 
function MaCompaniesRefineSearch({ customPathname }) {
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { setrefineSearchFilters,dbDropdown , setDbDropdown ,AllCities, onErrorHandler, refineSearchFilters, MinAcquirerDealRange, MaxAcquirerDealRange,setMonthPickerValue,Sectors, setSectors, targetGroup, setTargetGroup, acquirerGroup, setAcquirerGroup,TargetCompanyOptions,setTargetCompanyOptions ,setAcquirersOptions ,AcquirersOptions,setlAdvisorsOptions ,dropdown, lAdvisorsOptions ,tAdvisorsOptions ,settAdvisorsOptions, accessControl  } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(0);
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[customPathname]?.globalSearch?.length > 0 ? true : false

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState('keyword');
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [AcqIndustriesOptions, setAcqIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [CompanyTypeOptions, setCompanyTypeOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [targetGroupOptions, setTargetGroupOptions] = useState([]);
    const [acquirerGroupOptions, setAcquirerGroupOptions] = useState([]);
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [DealTypeOption, setDealTypeOption] = useState([])
    const [AcquirerCountryOptions, setAcquirerCountryOptions] = useState([])
    const [AcquirerRegionOptions, setAcquirerRegionOptions] = useState([])
    const [AcquirerStateOptions, setAcquirerStateOptions] = useState([])
    const [AcquirerCityOptions, setAcquirerCityOptions] = useState([])
    const [AcquirerTypeOptions, setAcquirerTypeOptions] = useState([])
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [ValuationOptions, setValuationOptions] = useState([])

    
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedAcqIndustries = AcqIndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = Sectors.filter(option => option.isChecked);
        const selectedGroup = targetGroupOptions?.filter(option => option.isChecked);
        const selectedAcquirerGroup = acquirerGroupOptions?.filter(opt => opt.isChecked);
        const selectedCompanyType = CompanyTypeOptions?.filter(option => option.isChecked);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedAcquirerType = AcquirerTypeOptions?.filter(option => option.isChecked);
        const selectedAcquirerCountries = AcquirerCountryOptions?.filter(option => option.isChecked);
        const selectedAcquirerRegion = AcquirerRegionOptions?.filter(option => option.isChecked);
        const selectedAcquirerState = AcquirerStateOptions?.filter(option => option.isChecked);
        const selectedAcquirerCity = AcquirerCityOptions?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedDealTypes = DealTypeOption?.filter(option => option.isChecked);
        const selectedValuations = ValuationOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedAcquirers = AcquirersOptions?.filter(option => option.isChecked); 
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);





        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                industry: selectedIndustries,
                acquirer_industry: selectedAcqIndustries,
                sector: selectedSectors,
                group : selectedGroup ,
                companyType: selectedCompanyType,
                countries: selectedCountries,
                region: selectedRegion,
                state: selectedState,
                city: selectedCity,
                acquirer_group: selectedAcquirerGroup,
                acquirers: selectedAcquirers,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                acquirerType: selectedAcquirerType,
                acquirerCountries: selectedAcquirerCountries,
                acquirerRegion: selectedAcquirerRegion,
                acquirerState: selectedAcquirerState,
                acquirerCity: selectedAcquirerCity,
                target_company:selectedTargetCompany,
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
                dealType: selectedDealTypes,
                valuations: selectedValuations,
            },
        }))
    }


    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setAcquirersOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setAcquirerGroupOptions([]);
        setTargetGroupOptions([]);
        setTargetGroup([]);
        setSectors([]);
        setAcquirerGroup([]);
    }


    // Submitting Refine Search Form 
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[]}
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
        setMonthPickerValue(Constants.initialMonthRange)
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(0)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }

    }

    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        // Reset all options to unchecked
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onCountryChange = (options, type) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                if (type === "acquirer") {
                    setAcquirerRegionOptions(response.data?.region)
                    setAcquirerStateOptions(response.data.state)
                    setAcquirerCityOptions(response.data?.city)
                } else {
                    setRegionOptions(response.data?.region)
                    setStateOptions(response.data.state)
                    setCityOptions(response.data?.city)
                }
            }
        }).catch(onErrorHandler)
    }

    
    
    const onRegionChange = (options, type) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        let selectedCountries = [];

        if (type === "acquirer") {
            selectedCountries = AcquirerCountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
        } else {
            selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
        }
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                if (type === "acquirer") {
                    setAcquirerStateOptions(response.data.state)
                    setAcquirerCityOptions(response.data?.city)
                } else {
                    setStateOptions(response.data.state)
                    setCityOptions(response.data?.city)
                }
            }
        }).catch(onErrorHandler)
    }

    const onStateChange = (options, type) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        let selectedCountries = [];
        let selectedRegion = [];

        if (type === "acquirer") {
            selectedCountries = AcquirerCountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
            selectedRegion = AcquirerRegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        } else {
            selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id)
            selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        }

        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                if (type === "acquirer") {
                    setAcquirerCityOptions(response.data?.city)
                } else {
                    setCityOptions(response.data?.city)
                }
            }
        }).catch(onErrorHandler)
    }

    const fetchGroupData = async () => {
        
        try {
            const response = await axios(filterGroupUrl,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data:{
                    industry_ids: accessControl?.maindustries?.id?.length > 0 ? accessControl?.maindustries.id : [],
                    country_ids: accessControl?.ma_countries?.id?.length ? accessControl?.ma_countries?.id : [],
                    region_ids:  accessControl?.ma_regions?.id?.length ? accessControl?.ma_regions?.id : [],
                    state_ids:  accessControl?.ma_stage?.id?.length ? accessControl?.ma_states?.id : [],
                    city_ids:  accessControl?.ma_cities?.id?.length ? accessControl?.ma_cities?.id : [],
                }
            });
            const hasCheckedItems = targetGroup.some(op => op.isChecked === true);
            console.log(targetGroup, 'checked options')
            if(hasCheckedItems){
                const merged = response.data.map(item => {
                    const selected = targetGroup.find(t => t.name === item.name); // or use name if id missing
                    return {
                        ...item,
                        isChecked: selected ? selected.isChecked : false
                    };
                });
                setTargetGroupOptions(merged);
                // Also update the targetGroup context state to keep it in sync
                setTargetGroup(merged);
            } else {
                setTargetGroupOptions(response.data);
                // Initialize targetGroup context state with the fresh data
                setTargetGroup(response.data);
            }
        } catch (error) {
            console.error('Error fetching target group options:', error);
        }
    };

    
    const fetchAcquirerData = async () => {
        try {
            const response = await axios(filterAcquirerGroupUrl,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: {
                        industry_ids: accessControl?.maindustries?.id?.length > 0 ? accessControl?.maindustries?.id : [],
                        country_ids: accessControl?.ma_countries?.id?.length ? accessControl?.ma_countries?.id : [],
                        region_ids: accessControl?.ma_regions?.id?.length ? accessControl?.ma_regions?.id : [],
                        state_ids: accessControl?.ma_stage?.id?.length ? accessControl?.ma_states?.id : [],
                        city_ids: accessControl?.ma_cities?.id?.length ? accessControl?.ma_cities?.id : [],
                    }
                }
            );
            const hasCheckedItems = acquirerGroup.some(op => op.isChecked === true);
            if(hasCheckedItems){
                const merged = response.data.map((item) => {
                    const selected = acquirerGroup.find(a => a.name === item.name)
                    return {
                        ...item,
                        isChecked: selected ? selected.isChecked : false
                    }
                })
                setAcquirerGroupOptions(merged);
                setAcquirerGroup(merged)
            } else {
                setAcquirerGroupOptions(response.data);
                setAcquirerGroup(response.data);
            }
        } catch (error) {
            console.error('Error fetching target group options:', error);
        }
    }


    useEffect(() => {
        fetchGroupData();
        fetchAcquirerData();
        console.log(targetGroupOptions);
      }, []); 

    // useEffect(() => {
    //     const ids = IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id);

    //     if (ids?.length > 0) {
    //         axios.post(filterSectorByIndutry, {
    //             "industry": ids,
    //             category: "investments"
    //         }, {
    //             headers: {
    //                 "Authorization": getToken()
    //             }
    //         }).then(response => {
    //             if (response.status == 200) {
    //                 setSectors(response.data?.data ?? [])
    //             } else {
    //                 setSectors([])
    //             }
    //         }).catch(onErrorHandler)
    //     } else {
    //         setSectors([])
    //     }

    // }, [IndustriesOptions])


    useEffect(() => {
        const countryIds = refineSearchFilters[customPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[customPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[customPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[customPathname]?.city?.map(value => value.id) ?? [];

        const acquirerCountryIds = refineSearchFilters[customPathname]?.acquirerCountries?.map(value => value.id) ?? [];
        const acquirerRegionIds = refineSearchFilters[customPathname]?.acquirerRegion?.map(value => value.id) ?? [];
        const acquirerStateIds = refineSearchFilters[customPathname]?.acquirerState?.map(value => value.id) ?? [];
        const acquirerCityIds = refineSearchFilters[customPathname]?.acquirerCity?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(AllCities?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))

                setAcquirerCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: acquirerCountryIds.includes(option.id) })))
                setAcquirerRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: acquirerRegionIds.includes(option.id) })))
                setAcquirerStateOptions(response.data.state?.map(option => ({ ...option, isChecked: acquirerStateIds.includes(option.id) })))
                setAcquirerCityOptions(response.data.city?.map(option => ({ ...option, isChecked: acquirerCityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters,AllCities])

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // Helper functions to count applied filters for each section
    const getKeywordFiltersCount = () => {
        let count = 0;
        if (TargetCompanyOptions?.filter(option => option.isChecked).length > 0) count++;
        if (targetGroupOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirersOptions?.filter(option => option.isChecked).length > 0) count++;
        if (acquirerGroupOptions?.filter(option => option.isChecked).length > 0) count++;
        if (lAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        if (tAdvisorsOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getTargetFiltersCount = () => {
        let count = 0;
        if (IndustriesOptions?.filter(option => option.isChecked).length > 0) count++;
        if (Sectors?.filter(option => option.isChecked).length > 0) count++;
        if (CompanyTypeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (CountryOptions?.filter(option => option.isChecked).length > 0) count++;
        if (RegionOptions?.filter(option => option.isChecked).length > 0) count++;
        if (StateOptions?.filter(option => option.isChecked).length > 0) count++;
        if (CityOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if (DealTypeOption?.filter(option => option.isChecked).length > 0) count++;
        if (MinDealRangeOptions?.filter(option => option.isChecked).length > 0 || MaxDealRangeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (ValuationOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

    const getAcquirerFiltersCount = () => {
        let count = 0;
        if (AcqIndustriesOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerTypeOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerCountryOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerRegionOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerStateOptions?.filter(option => option.isChecked).length > 0) count++;
        if (AcquirerCityOptions?.filter(option => option.isChecked).length > 0) count++;
        return count;
    };

console.log(dropdown,"lgujygjug")
    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-hidden">
                        <div className="h-full flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 mt-4">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-6 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-center md:items-stretch overflow-hidden flex-wrap md:flex-nowrap no-scrollbar">
                                {/* Keyword Search Section */}
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-1 md:gap-2 ${activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Deal Section */}
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-1 md:gap-2 ${activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {getDealFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getDealFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                {/* Target Section */}
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-1 md:gap-2 ${activeFilterSection === 'target' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'target' ? null : 'target')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Target</span>
                                        {getTargetFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'target' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getTargetFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'target' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>


                                {/* Acquirer Section */}
                                <div
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between gap-1 md:gap-2 ${activeFilterSection === 'acquirer' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'acquirer' ? null : 'acquirer')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Acquirer</span>
                                        {getAcquirerFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'acquirer' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getAcquirerFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'acquirer' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="col-span-full md:col-span-6 overflow-y-auto overflow-x-hidden md:overflow-y-auto md:overflow-x-hidden md:no-scrollbar mt-4 md:mt-0 pb-4 md:pb-0 relative">
                                {/* Keyword Search Content */}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-y-auto md:overflow-y-visible md:no-scrollbar`}>
                                    <div className="space-y-4">
                                        <div className="w-full min-w-0">
                                            <TargetCompany
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(16)}
                                                label="Target Company"
                                                open={select === 16}
                                            />
                                        </div>

                                        <div className="w-full min-w-0">
                                            <TargetGroup
                                                targetGroupOptions={targetGroupOptions}
                                                setTargetGroupOptions={setTargetGroupOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(15)}
                                                label="Target Group"
                                                open={select === 15}
                                                filterGroupUrl={filterGroupUrl}
                                            />
                                        </div>

                                        <div className="w-full min-w-0">
                                            <Acquirers 
                                                options={AcquirersOptions}
                                                setOptions={setAcquirersOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(17)}
                                                label="Acquirers"
                                                open={select === 17}
                                            />
                                        </div>
                                        
                                        <div className="w-full min-w-0">
                                            <AcquirerGroup
                                                acquirerGroupOptions={acquirerGroupOptions}
                                                setAcquirerGroupOptions={setAcquirerGroupOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(121)}
                                                label="Acquirer Group"
                                                open={select === 121}
                                                filterGroupUrl={filterAcquirerGroupUrl}
                                            />
                                        </div>

                                        <div className="w-full min-w-0">
                                            <LAdvisor 
                                                options={lAdvisorsOptions}
                                                setOptions={setlAdvisorsOptions}
                                                customPathname={customPathname}
                                                label="Legal Advisors"
                                                accordionClick={() => accordionClick(18)}
                                                open={select === 18}
                                            />
                                        </div>

                                        <div className="w-full min-w-0">
                                            <TAdvisor 
                                                options={tAdvisorsOptions}
                                                setOptions={settAdvisorsOptions}
                                                label="Transaction Advisors"
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(19)}
                                                open={select === 19}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Target Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'target' ? '' : 'hidden'}`}>
                                    <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(1)}
                                            label="Target Industry"
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'targetIndustry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetIndustry' : null)}
                                        />
                                        <SectorFilter
                                            setOptions={setSectors}
                                            options={Sectors}
                                            accordionClick={() => accordionClick(14)}
                                            customPathname={customPathname}
                                            label="Target Sector"
                                            open={select === 14}
                                            isPopupOpen={openFilterPopup === 'targetSector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetSector' : null)}
                                        />
                                        <CompanyTypeFilter
                                            CompanyTypeOptions={CompanyTypeOptions}
                                            setCompanyTypeOptions={setCompanyTypeOptions}
                                            customPathname={customPathname}
                                            label="Target Company Type"
                                            accordionClick={() => accordionClick(2)}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'targetCompanyType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetCompanyType' : null)}
                                        />
                                        <CountryFilter
                                            CountryOptions={CountryOptions}
                                            setCountryOptions={setCountryOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(3)}
                                            onChange={onCountryChange}
                                            label="Target Country"
                                            open={select === 3}
                                            isPopupOpen={openFilterPopup === 'targetCountry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetCountry' : null)}
                                        />
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(4)}
                                            onChange={onRegionChange}
                                            label="Target Region"
                                            open={select === 4}
                                            isPopupOpen={openFilterPopup === 'targetRegion'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetRegion' : null)}
                                        />
                                        <StateFilter
                                            StateOptions={StateOptions}
                                            setStateOptions={setStateOptions}
                                            customPathname={customPathname}
                                            onChange={onStateChange}
                                            accordionClick={() => accordionClick(5)}
                                            label="Target State"
                                            open={select === 5}
                                            isPopupOpen={openFilterPopup === 'targetState'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetState' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(6)}
                                            label="Target City"
                                            open={select === 6}
                                            isPopupOpen={openFilterPopup === 'targetCity'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'targetCity' : null)}
                                        />
                                    </div>

                                {/* Deal Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <DealTypeFilter
                                            DealTypeOption={DealTypeOption}
                                            setDealTypeOption={setDealTypeOption}
                                            accordionClick={() => accordionClick(13)}
                                            customPathname={customPathname}
                                            isMultiSelect={true}
                                            showAll={false}
                                            dataPath="ma"
                                            open={select === 13}
                                            isPopupOpen={openFilterPopup === 'dealType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealType' : null)}
                                        />
                                        <AcquirerDealRangeFilter
                                            customPathname={customPathname}
                                            MinDealOptions={MinDealRangeOptions}
                                            setMinDealOptions={setMinDealRangeOptions}
                                            MaxDealOptions={MaxDealRangeOptions}
                                            setMaxDealOptions={setMaxDealRangeOptions}
                                            MinDealRange={MinAcquirerDealRange}
                                            MaxDealrange={MaxAcquirerDealRange}
                                            isPopupOpen={openFilterPopup === 'dealRange'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                        />
                                        <ValuationFilter
                                            ValuationOptions={ValuationOptions}
                                            setValuationOptions={setValuationOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(12)}
                                            dataPath="maCompanies"
                                            open={select === 12}
                                            isPopupOpen={openFilterPopup === 'valuation'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'valuation' : null)}
                                        />
                                    </div>

                                {/* Acquirer Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'acquirer' ? '' : 'hidden'}`}>
                                    <AcqIndustryFilter
                                            IndustriesOptions={AcqIndustriesOptions}
                                            setIndustriesOptions={setAcqIndustriesOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(29)}
                                            label="Acquirer Industry"
                                            open={select === 29}
                                            isPopupOpen={openFilterPopup === 'acquirerIndustry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerIndustry' : null)}
                                        />
                                        <AcquirerTypeFilter
                                            AcquirerTypeOptions={AcquirerTypeOptions}
                                            setAcquirerTypeOptions={setAcquirerTypeOptions}
                                            customPathname={customPathname}
                                            label="Acquirer Company Type"
                                            accordionClick={() => accordionClick(7)}
                                            open={select === 7}
                                            isPopupOpen={openFilterPopup === 'acquirerType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerType' : null)}
                                        />
                                        <CountryFilter
                                            CountryOptions={AcquirerCountryOptions}
                                            setCountryOptions={setAcquirerCountryOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(8)}
                                            onChange={(options) => onCountryChange(options, 'acquirer')}
                                            filterPathkey="acquirerCountries"
                                            label='Acquirer Country'
                                            open={select === 8}
                                            isPopupOpen={openFilterPopup === 'acquirerCountry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerCountry' : null)}
                                        />
                                        <RegionFilter
                                            RegionOptions={AcquirerRegionOptions}
                                            setRegionOptions={setAcquirerRegionOptions}
                                            customPathname={customPathname}
                                            filterPathkey="acquirerRegion"
                                            label='Acquirer Region'
                                            accordionClick={() => accordionClick(9)}
                                            onChange={(options) => onRegionChange(options, 'acquirer')}
                                            open={select === 9}
                                            isPopupOpen={openFilterPopup === 'acquirerRegion'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerRegion' : null)}
                                        />
                                        <StateFilter
                                            StateOptions={AcquirerStateOptions}
                                            setStateOptions={setAcquirerStateOptions}
                                            customPathname={customPathname}
                                            onChange={(options) => onStateChange(options, 'acquirer')}
                                            filterPathkey="acquirerState"
                                            label='Acquirer State'
                                            accordionClick={() => accordionClick(10)}
                                            open={select === 10}
                                            isPopupOpen={openFilterPopup === 'acquirerState'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerState' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={AcquirerCityOptions}
                                            setCityOptions={setAcquirerCityOptions}
                                            filterPathkey="acquirerCity"
                                            label='Acquirer City'
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(11)}
                                            open={select === 11}
                                            isPopupOpen={openFilterPopup === 'acquirerCity'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'acquirerCity' : null)}
                                        />
                                    </div>

                                {/* Empty State */}
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    )
}

export default MaCompaniesRefineSearch